import { Controller } from "@hotwired/stimulus";

export default class SubmitButtonLoaderController extends Controller {
  connect() {
    this.element.addEventListener("turbo:submit-start", this.showLoader);
    this.element.addEventListener("turbo:submit-end", this.hideLoader);
  }

  disconnect() {
    this.element.removeEventListener("turbo:submit-start", this.showLoader);
    this.element.removeEventListener("turbo:submit-end", this.hideLoader);
  }

  showLoader = () => {
    const button = this.element.querySelector(".submit-button");

    if (!button) return;

    button.disabled = true;
    const loader = button.querySelector(".button-loader-spinner");
    if (loader) {
      loader.classList.remove("d-none");
    }
  };

  hideLoader = () => {
    const button = this.element.querySelector(".submit-button");

    if (!button) return;

    button.disabled = false;
    const loader = button.querySelector(".button-loader-spinner");
    if (loader) {
      loader.classList.add("d-none");
    }
  };
}
